import { cx } from '../lib/cx';
import styles from './Wordmark.module.css';

/** "dovefiniscono." — the full stop is where things end up, and the brand's only colour. */
export function Wordmark({ size = 'md' }: { size?: 'md' | 'lg' }) {
  return (
    <span className={cx(styles.wordmark, size === 'lg' && styles.large)}>
      dovefiniscono<span className={styles.dot}>.</span>
    </span>
  );
}
